module.exports = __webpack_public_path__ + "media/images/new_home/share-black-088c7456e3052aef4433cee7dc51c2db.png";